import * as types from "./types";

const mutations = {
    [types.LOADING_EMPLOYEE](state, value) {
        state.loading = value;
    },
    [types.GET_EMPLOYEE_LIST](state, employees) {
        state.employees = employees;
    },
    [types.REMOVE_EMPLOYEE](state, id) {        
        state.employees = state.employees.filter((x) => x.id !== id);        
    },
    [types.ADD_EMPLOYEE](state, employees) {        
        state.employees.unshift(employees);
    },
    [types.UPDATE_EMPLOYEE](state, employees) {        
        const EmployeeIndex = state.employees.findIndex((x) => x.id === employees.id);
        state.employees[EmployeeIndex] = employees;        
    },
    [types.GET_EMPLOYEEID](state, id) {
        state.employeeid = id;
    },
    //#region Document

    [types.LOADING_EMPLOYEE_DOC](state, value) {
        state.loading = value;
    },
    [types.GET_EMPLOYEE_LIST_DOC](state, employeeDocs) {
        state.employeeDocs = employeeDocs;
    },
    [types.REMOVE_EMPLOYEE_DOC](state, id) {        
        state.employeeDocs = state.employeeDocs.filter((x) => x.id !== id);        
    },
    [types.ADD_EMPLOYEE_DOC](state, employeeDocs) {        
        state.employeeDocs.unshift(employeeDocs);
    },
    [types.UPDATE_EMPLOYEE_DOC](state, employeeDocs) {        
        const EmployeeDocIndex = state.employeeDocs.findIndex((x) => x.id === employeeDocs.id);
        state.employeeDocs[EmployeeDocIndex] = employeeDocs;        
    },
    [types.GET_EMPLOYEEID_DOC](state, id) {
        state.employeeDocId = id;
    }

    //#endregion
};

export default mutations;